import { isSSR } from 'lib/helpers/isSSR/isSSR'

/**
 * An abstraction over localStorage.getItem to handle SSR renders
 * @param {string} key local storage key
 * @returns {(string|null)}
 */
export const getLSItem = (key: string) => (isSSR() ? null : window.localStorage.getItem(key))
